import React from 'react';
import { useInstantSearch } from 'react-instantsearch';

export default function NoResultsBoundary({ children, fallback }) {
  const { results } = useInstantSearch();

  if (results.nbHits === 0) {
    return (
        <>
          {fallback}
          <div hidden>{children}</div>
        </>
    );
  }

  return children;
}
